module.exports = __webpack_public_path__ + "public/img/discord.62a80049.svg";